document.addEventListener("DOMContentLoaded", function () {
  const COMPARE_KEY = "shopify-compare";
  const compare = JSON.parse(localStorage.getItem(COMPARE_KEY)) || [];
  const grid = document.querySelector(".compare-grid");

  // Handle empty compare list
  if (!compare.length) {
    grid.innerHTML = "<p>Your compare list is empty.</p>";
    return;
  }

  fetch("/products.json")
    .then((res) => res.json())
    .then((data) => {
      const products = data.products.filter((product) =>
        compare.includes(product.handle)
      );

      // Handle if no products match the compare list
      if (!products.length) {
        grid.innerHTML =
          "<p>No matching products found in your compare list.</p>";
        return;
      }

      grid.innerHTML = `
        <table class="compare-table">
          <thead>
            <tr>
              <th>Product</th>
              <th>Remove</th>
            </tr>
          </thead>
          <tbody>
            ${products
              .map((product) => {
                const image =
                  product.images[0]?.src || "https://via.placeholder.com/150";
                return `
                <tr class="compare-item">
                  <td>
                    <a href="/products/${product.handle}" class="product-link">
                      <img src="${image}" width="50" height="50" loading="lazy" alt="${product.title}" />
                      <h4 class"card__heading_product h4">${product.title}</h4>
                    </a>
                  </td>
                  <td>
                    <button class="button button--primary remove-btn" data-handle="${product.handle}">Remove</button>
                  </td>
                </tr>
              `;
              })
              .join("")}
          </tbody>
        </table>
      `;

      // Attach event listeners to remove buttons
      document.querySelectorAll(".remove-btn").forEach((button) => {
        button.addEventListener("click", (e) => {
          const productHandle = e.target.dataset.handle;
          removeFromCompare(productHandle, e.target);
        });
      });
    })
    .catch((error) => {
      console.error("Error loading compare products:", error);
      grid.innerHTML = "<p>Error loading compare products.</p>";
    });
});

// Remove from Compare via AJAX
function removeFromCompare(handle, buttonElement) {
  // Remove product handle from localStorage compare list
  let compare = JSON.parse(localStorage.getItem("shopify-compare")) || [];
  compare = compare.filter((item) => item !== handle);
  localStorage.setItem("shopify-compare", JSON.stringify(compare));

  // Update the table row (remove the product from the DOM)
  const row = buttonElement.closest("tr");
  row.classList.add("removing");
  setTimeout(() => row.remove(), 300); // Give time for animation

  // Optionally, show a message or update some UI
  const grid = document.querySelector(".compare-grid");
  if (compare.length === 0) {
    grid.innerHTML = "<p>Your compare list is empty.</p>";
  }
}
